module.exports = __webpack_public_path__ + "img/Zieh.73ec5a51.svg";